import { RemoteVerifyInternshipResponsibleEmail } from 'data/usecases';
import { makeApiUrlInternshipResponsibleEmail } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteVerifyInternshipResponsibleEmail =
  (): RemoteVerifyInternshipResponsibleEmail => {
    return new RemoteVerifyInternshipResponsibleEmail(
      makeApiUrlInternshipResponsibleEmail(),
      makeAxiosHttpClient(),
    );
  };
